import type { ReactNode } from 'react';

interface PageHeaderProps {
    title: string;
    children?: ReactNode;
}

/**
 * Consistent page header component with title and optional action slot.
 * Ensures uniform vertical spacing across all pages (40px min-height).
 */
export function PageHeader({ title, children }: PageHeaderProps) {
    return (
        <div className="flex min-h-[40px] items-center justify-between">
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                {title}
            </h1>
            {children}
        </div>
    );
}
